
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useTopBreeders = () => {
  return useQuery({
    queryKey: ['top-breeders'],
    queryFn: async () => {
      try {
        const { data, error } = await supabase
          .from('top_breeders')
          .select(`
            id,
            breeder_id,
            display_order,
            profiles:breeder_id (
              id,
              first_name,
              last_name,
              business_name,
              profile_image_url,
              cover_image_url,
              location,
              description,
              breeds
            )
          `)
          .order('display_order', { ascending: true });

        if (error) {
          console.error('Error fetching top breeders:', error);
          throw error;
        }

        // Transform the data to match the expected format for BreederProfileCard
        return data?.map(item => ({
          id: item.profiles?.id || '',
          name: item.profiles?.business_name || `${item.profiles?.first_name || ''} ${item.profiles?.last_name || ''}`.trim() || 'Unknown Breeder',
          profileImage: item.profiles?.profile_image_url,
          coverImage: item.profiles?.cover_image_url,
          location: item.profiles?.location || '',
          description: item.profiles?.description || '',
          breeds: Array.isArray(item.profiles?.breeds) 
            ? item.profiles.breeds.filter((breed): breed is string => typeof breed === 'string')
            : []
        })) || [];
      } catch (error) {
        console.error('Error in useTopBreeders:', error);
        return [];
      }
    },
    retry: 1,
    retryDelay: 1000,
  });
};
